module.exports = __webpack_public_path__ + "img/album20_04.eba761e4.jpg";